module.exports = __webpack_public_path__ + "static/img/tab2.3ebd880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab2.png
// module id = Dhgw
// module chunks = 0